import { render } from "./NavigatorBox.vue?vue&type=template&id=0a917280"
import script from "./NavigatorBox.vue?vue&type=script&lang=js"
export * from "./NavigatorBox.vue?vue&type=script&lang=js"

import "./NavigatorBox.vue?vue&type=style&index=0&id=0a917280&lang=css"
script.render = render

export default script